import { render, staticRenderFns } from "./Cadastro.vue?vue&type=template&id=2252574a&scoped=true"
import script from "./Cadastro.vue?vue&type=script&setup=true&lang=js"
export * from "./Cadastro.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Cadastro.vue?vue&type=style&index=0&id=2252574a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2252574a",
  null
  
)

export default component.exports